import { StanButton } from '@/components';
import { SvgIcon } from '@/types';
import { BareSvg } from '@/lib';
import { StanIcon } from '@/components/core-components/types';

interface EmptyStateLayoutProps {
    title: string;
    description: string;
    bulletPointsHeading?: string;
    bulletPoints: string[];
    buttonText: string;
    buttonIcon?: StanIcon;
    buttonName: string;
    onButtonClick: () => void;
    illustration: SvgIcon;
    imageAlt: string;
}

/**
 * Shared layout component for empty states in Email Flows
 * Used by FlowEmptyState and BroadcastEmptyState
 * Matches IntroductionStep layout exactly
 */
export const EmptyStateLayout = ({
    title,
    description,
    bulletPointsHeading,
    bulletPoints,
    buttonText,
    buttonIcon,
    buttonName,
    onButtonClick,
    illustration,
    imageAlt,
}: EmptyStateLayoutProps) => {
    return (
        <div className='flex w-full flex-col items-start px-2'>
            <div className='mt-[5%] flex w-full flex-col gap-6 sm:gap-8 sm:px-4 md:gap-12 md:px-8 lg:px-12 xl:px-14'>
                <p className='text-semantic-fg-base text-4xl font-extrabold md:text-4xl xl:text-5xl'>{title}</p>
                <div className='flex w-full justify-between gap-4 lg:gap-6'>
                    <div className='flex w-full flex-col gap-8 pr-1 md:gap-12'>
                        <div className='text-semantic-fg-muted'>
                            <p className='pb-4 font-semibold md:max-w-72 md:pb-6 md:text-balance lg:max-w-full'>
                                {description}
                            </p>
                            <div className=''>
                                {bulletPointsHeading && <p className='pb-2'>{bulletPointsHeading}</p>}
                                <ul className='translate-x-6 list-disc'>
                                    {bulletPoints.map(point => (
                                        <li key={point}>{point}</li>
                                    ))}
                                </ul>
                            </div>
                        </div>
                        <div>
                            <StanButton
                                name={buttonName}
                                onClick={onButtonClick}
                                icon={buttonIcon}
                                className='md:text-base!'
                            >
                                {buttonText}
                            </StanButton>
                        </div>
                    </div>
                    <div className='w-full max-md:hidden lg:-translate-y-12 xl:pr-24'>
                        <BareSvg
                            SvgComponent={illustration}
                            className='pointer-events-none ml-auto w-full max-w-[650px] object-contain select-none'
                            aria-label={imageAlt}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};
